import { render, staticRenderFns } from "./TableInterconsultas.vue?vue&type=template&id=33619197"
import script from "./TableInterconsultas.vue?vue&type=script&lang=js"
export * from "./TableInterconsultas.vue?vue&type=script&lang=js"
import style0 from "./TableInterconsultas.vue?vue&type=style&index=0&id=33619197&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports